import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ShopfloorOverviewComponent } from './shopfloor-overview/shopfloor-overview.component';
import { SummaryCsvComponent } from './summary-csv/summary-csv.component';
import { SummaryComponent } from './summary/summary.component';


const routes: Routes = [
  {
    path : 'summary',
    component : SummaryComponent,
  },
  {
    path : 'summary-advanced',
    component : SummaryCsvComponent,
  },
  {
    path : 'shopfloor_overview',
    component : ShopfloorOverviewComponent,
  },
  {
    path : '**',
    component: DashboardComponent,
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
